export * from './photo-upload.component';
export * from './select-photo/select-photo.component';
